import * as React from "react";

export const authorizeProducts = (wrappedComponent: React.ReactNode, customer: { products?: string[] }, productTypes: string | string[]) => {
    if (!customer.products) {
        return null;
    }
    const productsArray = Array.isArray(productTypes) ? productTypes : [ productTypes ];
    if (productsArray.some(p => customer.products.indexOf(p) !== -1)) {
        return wrappedComponent;
    }
    return null;
};
